<template>
  <div class="d-flex">
    <div class="mr-auto align-self-center">
      <div class="tw:flex tw:items-baseline tw:gap-2">
        <h2 class="mb-0">{{ metric.value.percentage }}%</h2>
        <DeltaBadge v-if="metric.delta" :delta="metric.delta" size="lg" />
      </div>
      <small class="text-muted">{{ metric.value.value }} / {{ metric.value.total }}</small>
    </div>
    <div class="align-self-center">
      <DoughnutChart :datacollection="datacollection" :options="options" :width="50" :height="50" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DoughnutChart from '@/components/charts/DoughnutChart.vue';
import DeltaBadge from './DeltaBadge.vue';
import { COMPARISON_COLORS, type PercentageMetricData } from './metrics';

const props = defineProps<{
  metric: PercentageMetricData
}>();

const datacollection = computed(() => ({
  labels: ['Value', 'Total'],
  datasets: [{
    label: '',
    backgroundColor: [COMPARISON_COLORS.current, 'rgb(237, 237, 237)'],
    data: [props.metric.value.percentage, 100 - props.metric.value.percentage],
  }],
}));

const options = {
  responsive: true,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
};
</script>
